import React, { useState, useRef, useEffect } from 'react';
import { LuSearch, LuChevronDown, LuX } from 'react-icons/lu';

function CoinSelector({ coins, selectedCoin, onSelect, lang }) {
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    const currentCoin = coins.find(c => c.symbol === selectedCoin);

    // Filter coins based on search
    const filteredCoins = coins.filter(coin => {
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase();
        return coin.shortName.toLowerCase().includes(q) ||
               coin.name.toLowerCase().includes(q) ||
               coin.symbol.toLowerCase().includes(q);
    });

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchQuery('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Focus input when dropdown opens
    useEffect(() => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen]);

    const handleSelect = (coin) => {
        onSelect(coin.symbol);
        setIsOpen(false);
        setSearchQuery('');
    };

    const getCoinIcon = (shortName) => {
        return `https://assets.coincap.io/assets/icons/${shortName.toLowerCase()}@2x.png`;
    };

    return (
        <div className="coin-selector-dropdown" ref={dropdownRef}>
            <button
                type="button"
                className={`coin-selector-trigger ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {currentCoin ? (
                    <div className="selected-coin">
                        <img
                            src={getCoinIcon(currentCoin.shortName)}
                            alt={currentCoin.shortName}
                            className="coin-mini-icon"
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        <span className="coin-short">{currentCoin.shortName}</span>
                        <span className="coin-name-text">{currentCoin.name}</span>
                    </div>
                ) : (
                    <span className="placeholder">
                        {lang === 'tr' ? 'Coin seçin...' : 'Select coin...'}
                    </span>
                )}
                <LuChevronDown className={`chevron ${isOpen ? 'rotated' : ''}`} />
            </button>

            {isOpen && (
                <div className="coin-selector-menu">
                    <div className="coin-search-box">
                        <LuSearch className="search-icon" />
                        <input
                            ref={inputRef}
                            type="text"
                            placeholder={lang === 'tr' ? 'Coin ara...' : 'Search coin...'}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                        />
                        {searchQuery && (
                            <button
                                className="clear-search"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSearchQuery('');
                                }}
                            >
                                <LuX />
                            </button>
                        )}
                    </div>
                    <div className="coin-list">
                        {filteredCoins.length > 0 ? (
                            filteredCoins.map(coin => (
                                <button
                                    key={coin.symbol}
                                    type="button"
                                    className={`coin-option ${coin.symbol === selectedCoin ? 'selected' : ''}`}
                                    onClick={() => handleSelect(coin)}
                                >
                                    <img
                                        src={getCoinIcon(coin.shortName)}
                                        alt={coin.shortName}
                                        className="coin-mini-icon"
                                        onError={(e) => e.target.style.display = 'none'}
                                    />
                                    <div className="coin-option-info">
                                        <span className="coin-option-symbol">{coin.shortName}</span>
                                        <span className="coin-option-name">{coin.name}</span>
                                    </div>
                                    <span className={`coin-option-price ${coin.priceChangePercent >= 0 ? 'positive' : 'negative'}`}>
                                        {coin.price > 0
                                            ? `$${coin.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                            : (lang === 'tr' ? 'Bekleniyor' : 'Waiting')
                                        }
                                    </span>
                                </button>
                            ))
                        ) : (
                            <div className="no-results">
                                {lang === 'tr' ? 'Coin bulunamadı' : 'No coins found'}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default CoinSelector;
